<template>
  <div class="radios-con">
    <b-form-group
      class="custom-radios custom-activeRadio signout-mode"
      :label="
        field.is_mandatory && !field.is_optional
          ? field.name
          : field.name + ` ${$t('common.optionalWithBrackets')}`
      "
    >
      <!-- <b-form-radio-group
        v-model="radioModel.value"
        :options="options"
        :id="field.id"
      /> -->
      <v-radio-group
        v-model="radioModel.value"
        class="customField-radio"
        @change="radioChanged"
      >
        <v-radio
          :id="field.id"
          v-for="option in options"
          :key="option"
          :label="option"
          :value="option"
        ></v-radio>
      </v-radio-group>
    </b-form-group>
  </div>
</template>

<script>
import { cloneDeep } from "lodash";

export default {
  props: {
    field: {},
  },
  data() {
    return {
      options: null,
      radioModel: null,
      previouslySelected: null,
    };
  },
  beforeMount() {
    this.radioModel = cloneDeep(this.field);
    this.previouslySelected = cloneDeep(this.field.value);
    this.options = this.field.metadata[0].options;

    setTimeout(() => {
      const radioElement = document.getElementById(this.field.id);
      radioElement.addEventListener("click", (ev) => {
        if (!ev.target.value) return;
        if (this.previouslySelected == ev.target.value) {
          this.radioModel.value = null;
          this.previouslySelected = null;
        } else {
          this.previouslySelected = ev.target.value;
          this.radioModel.value = ev.target.value;
        }
        this.$emit("updateField", this.radioModel);
      });
    }, 0);
  },
  methods: {
    radioChanged(val) {
      console.log("radioChanged", val);
      if (!val) return;
      if (this.previouslySelected == val) {
        this.radioModel.value = null;
        this.previouslySelected = null;
      } else {
        this.previouslySelected = val;
        this.radioModel.value = val;
      }
      this.$emit("updateField", this.radioModel);
    },
  },
};
</script>
<style lang="scss">
.customField-radio .v-input--radio-group__input {
  display: grid;
}
.radios-con {
  .custom-control {
    padding-inline-start: 0 !important;
  }
  .custom-control-label::before {
    border: solid #103f5e 2.5px !important;
  }
  .form-group {
    margin-bottom: 0rem !important;
  }
  .col-form-label {
    color: #4A4A4A !important;
    font-weight: 600;
    font-size: 16px;
    line-height: 19.2px;
    margin-bottom: 32px !important;
    padding-bottom: 0px !important;
  }
  .custom-control-inline:not(:last-child) {
    display: block;
    margin-bottom: 32px;
  }
  .custom-activeRadio .custom-radio .custom-control-label span {
    color: #787878 !important;
    font-weight: 600;
    font-size: 16px;
    line-height: 17px;
    top: 5px !important;
    padding-inline-start: 12px !important;
    padding-top: 1px;
  }
  .custom-activeRadio
    .custom-radio
    .custom-control-input:checked
    ~ .custom-control-label
    span {
    color: #103f5e !important;
    font-weight: 700;
    padding-inline-start: 12px !important;
  }
}
</style>
